import { z } from 'zod';

// Error schema for the annotations operations api
export const OperationsBackEndErrorSchema = z.object({
  status: z.number(),
  message: z.string(),
});
export type OperationsBackEndError = z.infer<
  typeof OperationsBackEndErrorSchema
>;
